import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./../home/home.css";
import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import InteraktScript from "../../common/InteraktScript";
import { FaShoppingCart } from "react-icons/fa";
function PricingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [userid, setUserid] = useState(0);
  useEffect(() => {
    const userIdValue = localStorage.getItem("userId");
    setUserid(userIdValue);
  }, [userid]);
  const navigate = useNavigate();

  const tdStyle = {
    border: "1px solid #dee2e6",
    padding: "0.75rem",
    verticalAlign: "top",
  };

    useEffect(() => {
    const localdata = localStorage.getItem("isPaidUser");

    if (!localdata && !document.getElementById("calendly-script")) {
      const script = document.createElement("script");
      script.id = "calendly-script";
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const handleCalendlyClick = (e) => {
    e.preventDefault();
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/myprega/1-to-1",
      });
    } else {
      alert("Calendly is still loading. Please try again in a moment.");
    }
  };

    const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    updateScreenSize();
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  return (
    <div className="new-home">
      <Header userid={userid} />

      <div className="banner-container position-relative round-back margin-top  ">
        <div className="container-fluid   py-5">
          <div className="row align-items-center ">
            <div className="col-md-6">
              <h1 className="hero-title text-red">
                The Complete Pregnancy Care You Deserve — At a Price You Can Trust
              </h1>
              <p className="under-subtitle py-4 text-gray-600"> Every pregnant woman in India spends ₹70,000 or more during her 9-month
                                                                journey. The problem? It happens in dozens of small, untracked payments, leaving you feeling
                                                                like you're managing it all alone.
              </p>
              <p className="under-subtitle py-4 text-gray-600">At Myprega, we believe you deserve more than just random tests and rushed visits. You
                                                               deserve a clear plan, a dedicated team, and complete peace of mind, every single day. That’s
                                                               why we created India’s only all-in-one, technology-powered pregnancy package — at a price
                                                               that will surprise you.</p>
              <p
                style={{
                  fontSize: "28px",
                  fontWeight: "bolder",
                  color: "#d93e74",
                }}
              >
                With Myprega, you get full care + full support — for the same cost (or even less).
              </p>
              {/* <Link to="/Confirm-Pregnancy-Form" className="round-btn btn-icon">
                <FaShoppingCart style={{ marginRight: "8px" }} />
                Book Now
              </Link> */}
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/PricingPageHero.png" alt="nt found"></img>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-light py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/PricingPage2.png" className="w-100" alt="nt found" />
            </div>
            <div className="col-md-6 ">
              <h2 className="hero-title text-red">
                The ₹70,000 Question: Do You Know What You're Really Paying For?
              </h2>

              <p className="bold-font"> We've spoken to over 300 expecting mothers. They go to the best clinics, but they all share a
                                  similar feeling: their care is broken. It's a confusing puzzle of appointments, tests, and payments
                                  that they have to piece together themselves. Pregnancy isn't just about checkups and scans —
                                  it’s also about daily wellbeing, your mental health, nutrition, movement, and that peace of mind
                                  that everything is being looked after
              </p>
              <p className="bold-font" style={{ paddingTop: "10px" }}>
                Does this sound familiar?
              </p>
              <div style={{ marginTop: "18px" }}>
                <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                  <div className="benefit-icon green">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                      🤔 Confusion & Doubt: "Am I doing the right test? Did I forget to ask the doctor
                      something important?"
                    </h3>
                  </div>
                </div>
                <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                  <div className="benefit-icon blue">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                       The Management Burden: Feeling like you are your own project manager, juggling
                      reports, appointments, and advice from everyone
                    </h3>
                  </div>
                </div>
                <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                  <div className="benefit-icon orange">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                       Late-Night Googling: Relying on the internet for urgent questions, leading to more
                       anxiety, not less.
                    </h3>
                  </div>
                </div>
                <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                  <div className="benefit-icon orange">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                      Financial Surprises: You pay per visit, per scan, per test. The costs add up, but there's
                      no clear budget or plan. You never see the total amount in one place.
                    </h3>
                  </div>
                </div>
              </div>
              <p
                className="bold-font"
                style={{ paddingBottom: "10px", fontSize: "20px" }}
              >
                Let's break down the typical 9-month journey (a conservative estimate):
              </p>
                <ul className="searches-list">
                <li> 9-10 Gynaecologist Consultations: (at ₹800-₹1500 each) ≈ ₹12,000</li>
                <li> 5-6 Basic Ultrasound Scans: (including NT, Anomaly scans) ≈ ₹21,000</li>
                <li>Essential Blood Tests & Screenings: (For all 3 trimesters) ≈ ₹22,000</li>
                <li>Complications Charges if Arise: (prescribed throughout) ≈ ₹5,000</li>
                <li>Miscellaneous Costs: (Extra visits, travel, small procedures) ≈ ₹10,000</li>
              </ul>
            </div>
          </div>
            <p style={{ textAlign: "center" , fontSize: "24px" , fontWeight: "bold" , color: "#ff43a3"}}>Total Estimated Spend for Basic Care: ≈ ₹70,000+</p>
            <p style={{ textAlign: "center" , fontSize: "18px" , color: "#4c00fc" }}>And for all that money and effort, what do you get? A folder of reports, a handful of 10-minute
               consultations, and the entire responsibility of your and your baby's well-being on your shoulders
               with no tracking, no daily care, and no real plan.</p>
        </div>
      </div>

      <div className="bg-white">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="hero-title text-red">
                 We Knew There Had to Be a Better Way.
              </h2>

              <p className="bold-font" style={{paddingBottom: "10px"}}>
                    That’s exactly why we created Myprega. It’s not just an alternative to a hospital — it’s a
                    complete care system built around you, your baby, and your peace of mind</p>
                    <p className="bold-font">
                    We take the broken pieces of traditional care and unite them into one seamless, supportive
                    experience, powered by empathy, doctors and technology.</p>
                <div className="benefit-item" style={{ paddingTop: "20px" }}>
                  <div className="benefit-icon green">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                      <span style={{ fontWeight: 800 }}>
                      A Team That Cares, Not Just a Clinic That Treats: 
                      </span>
                    <span style={{ fontWeight: 400 }}>
                       {" "}You get a dedicated team of 9 experts
                      (Gynaecologists, Dietitians, Mental Health experts, Yoga instructors & more) who collaborate on
                      your care.
                      </span>
                    </h3>
                  </div>
                </div>
               <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                 <div className="benefit-icon orange">
                   <span className="icon">✔️</span>
                 </div>
                 <div className="benefit-content">
                   <h3 className="benefit-title">
                     <span style={{ fontWeight: 800 }}>
                     A Proactive Plan, Not a Reactive Cycle: 
                     </span>
                     <span style={{ fontWeight: 400 }}>
                      {" "}Your entire 9-month journey is pre-planned. No
                     wondering what’s next. We guide you through every test, every milestone at your fingertip
                     gh our tech platform.
                     </span>
                   </h3>
                 </div>
               </div>
                <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                  <div className="benefit-icon orange">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                      <span style={{ fontWeight: 800 }}>
                      Daily Health Tracking, Not Just Monthly Visits:
                      </span>
                      <span style={{ fontWeight: 400 }}> 
                          {" "}Our team tracks your health vitals daily
                      through our smart platform. We spot potential issues before they become problems. We believe
                      on prevention-focused care
                      </span>
                    </h3>
                  </div>
                </div>
                <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                  <div className="benefit-icon orange">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                      <span style={{ fontWeight: 800 }}>
                        A Proactive Plan, Not a Reactive Cycle:
                      </span>
                      <span style={{ fontWeight: 400 }}>
                        {" "}Your entire 9-month journey is pre-planned. No wondering what’s next. We guide you through every test, every milestone at your fingertip through our tech platform.
                      </span>
                    </h3>
                  </div>
                </div>
                <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                  <div className="benefit-icon orange">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                      <span style={{ fontWeight: 800 }}>
                      Daily Celebration of Every Stage: 
                      </span>
                  <span style={{ fontWeight: 400 }}>
                   {" "}We turn every day of our mom's 9-month pregnancy
                      journey into a celebration they’ll remember forever. At Myprega, Pregnancy not a 9-month
                      medical condition to be managed; it's a 270-day journey of creation to be cherished.
                      </span>
                    </h3>
                  </div>
                </div>
              {/* <p className="bold-font">
                💬 “We believe in listening before treating. At Myprega, every
                woman’s journey is unique — and deeply respected.” – Team
                Myprega
              </p> */}
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/PricingPage3.png" className="w-100" alt="nt found" />
            </div>
          </div>
        </div>
      </div>

      <div style={{ backgroundColor: "#f8f9fa", padding: "3rem 0" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/PricingPage4.png" className="w-100" alt="not found" />
            </div>
            <div className="col-md-6">
              <h2 className="hero-title text-red">
                See the Difference for Yourself
              </h2>
              <p className="bold-font" style={{marginBottom:"18px"}}>
                    Don't just take our word for it. Here’s a clear comparison of what you get in a typical pregnancy
                    journey versus the Myprega Cherish Care Package.
                </p>

                <div style={{ width: '100%' }}>
                  <table
                    style={{
                      width: "100%",
                      tableLayout: "fixed",
                      borderCollapse: "collapse",
                      border: "1px solid #dee2e6",
                      fontSize: "16px",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            border: "1px solid #dee2e6",
                            padding: "0.5rem",
                            color: "#dc3545",
                            backgroundColor: "#f1f1f1",
                            textAlign: "left",
                            wordWrap: "break-word",
                          }}
                        >
                          Feature
                        </th>
                        <th
                          style={{
                            border: "1px solid #dee2e6",
                            padding: "0.5rem",
                            color: "#dc3545",
                            backgroundColor: "#f1f1f1",
                            textAlign: "left",
                            wordWrap: "break-word",
                          }}
                        >
                          Typical Basic Care (in a Clinic/Hospital)
                        </th>
                        <th
                          style={{
                            border: "1px solid #dee2e6",
                            padding: "0.5rem",
                            color: "#dc3545",
                            backgroundColor: "#f1f1f1",
                            textAlign: "left",
                            wordWrap: "break-word",
                          }}
                        >
                          Myprega Cherish Care Package
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Doctors Consultations", "9-10 (Standard)", "44 Consultations (Team of 9 doctors)"],
                        ["Dedicated Care Team", "1 Doctor", "Team of 9 Experts (Gynac, Diet, Yoga, Lactation, Physician & More)"],
                        ["Daily Health Tracking", "❌ Not Available", "✅ Daily Vitals & Symptom Tracking and Analysis"],
                        ["Personalised Diet Plan", "❌ General Advice Only", "✅ 5 Sessions + Custom Plan for Every Week (1 to 1)"],
                        ["Prenatal Yoga & Fitness", "❌ Not Included", "✅ Daily Live Sessions"],
                        ["Mental & Emotional Health Support", "❌ Rarely Addressed", "✅ Daily Live Sessions"],
                        ["Garbhasanskar Sessions", "❌ Not Included", "✅ Included (Daily)"],
                        ["Advanced Ultrasounds", "5-6 Basic Scans Only", "✅ All Basic & Advanced Scans Included (9 Scans)"],
                        ["24/7 Emergency Helpline", "Hospital Timings Only", "✅ 24/7 Daily Doctor Support"],
                        ["End-to-End Journey Management", "You Manage Everything ", "✅ Managed For You via Myprega App"],
                        ["Total Estimated Cost", "₹65,000 - ₹75,000+", "₹69,999"],
                      ].map(([feature, basicCare, myprega], i) => (
                        <tr key={i}>
                          {[feature, basicCare, myprega].map((text, idx) => (
                            <td
                              key={idx}
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "0.5rem",
                                wordWrap: "break-word",
                                verticalAlign: "top",
                              }}
                            >
                              {text}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
            </div>
          </div>
          <p style={{ textAlign: "center" , fontSize: "18px", paddingTop: "10px" ,color: "#0084f5"}}>The Verdict: The truth is — a mom spends ₹70,000+ already, and she doesn't even get half the
                    care we provide. It’s just broken into random payments that no one tracks. For roughly the same
                    price or even less you're already paying for scattered, basic care, you get 9x the value, a full
                    expert team, and complete peace of mind with Myprega.</p>
        </div>
      </div>

        <div className="bg-white">
          <div className="container py-5">
           <div className="row align-items-center">
             {/* Left Content */}
             <div className="col-md-6">
               <h2 className="hero-title text-red">
                 🍼 Your Complete 9-Month Pregnancy Journey — for Less Than What Most Moms Pay for Just Basic Care
               </h2>
         
               <div
                 style={{
                   backgroundColor: "#f9f9f9",
                   padding: "20px",
                   borderRadius: "12px",
                   borderLeft: "5px solid #dc3545",
                   marginBottom: "20px",
                 }}
               >
                 <p style={{ margin: 0, fontWeight: "500", color: "#333" }}>
                   The <strong>Myprega Cherish Care Package</strong> includes everything mentioned above, with a single, transparent investment in your and your baby’s health.
                 </p>
               </div>
         
               <div
                 style={{
                   backgroundColor: "#fff4e6",
                   border: "1px solid #ffc107",
                   borderRadius: "12px",
                   padding: "20px",
                   marginBottom: "20px",
                 }}
               >
                 <h3 style={{ color: "#28a745", fontSize: "26px", fontWeight: "bold" }}>
                   ₹69,999
                 </h3>
                 <p style={{ margin: 0, fontSize: "15px", color: "#555" }}>
                   <strong>All Inclusive for 10 Months</strong> — Everything included. No hidden charges. No surprises.
                 </p>
               </div>
         
               <div style={{ marginBottom: "25px" }}>
                 <h5 style={{ fontWeight: "bold", color: "#343a40", marginBottom: "10px" }}>
                   Feeling overwhelmed by the number? We understand.
                 </h5>
                 <p style={{ margin: 0 }}>
                   That's why we've made it easier than ever to get the care you deserve.<strong>
                   Easy Monthly Instalments (EMI)</strong> Start your complete care journey for just <strong> ₹7,780 / month (For
                   10 Months).</strong> (Options for 3, 6, and 9-month EMIs available with most major banks)
                 </p>
               </div>
              <div
                style={{
                  position: "relative", 
                  backgroundColor: "#e7f7ed",
                  border: "2px dashed #28a745",
                  borderRadius: "12px",
                  padding: "20px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                  marginBottom: "20px",
                }}
              >
                    <img
                      src="/truststamp.png"
                      alt="Trustate Stamp"
                      style={{
                        position: "absolute",
                        top: isMobile ? "-20px" : "-30px",
                        right: isMobile ? "-1px" : "-10px",
                        width: isMobile ? "100px" : "150px",
                        height: isMobile ? "100px" : "150px",
                        zIndex: 2,
                      }}
                    />
              
                <h2
                  className="text-red"
                  style={{
                    fontWeight: "700",
                    fontSize: "28px",
                    lineHeight: "1.4",
                    marginBottom: "20px",
                  }}
                >
                  Our Trust Guarantee — No Risk, Just Care
                </h2>
              
                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <span role="img" aria-label="trust" style={{ fontSize: "24px", marginRight: "10px" }}>
                    🔒
                  </span>
                  <h4 style={{ margin: 0, fontWeight: "bold", color: "#dc3545" }}>
                    Our Trust Guarantee — No Risk, Just Care
                  </h4>
                </div>
              
                <p style={{ marginBottom: "5px", color: "#333", fontSize: "15px" }}>
                  We are creating a new category of care, and we know that trust is earned. We are so confident
                  in the value and quality of our service that we want to make this decision completely risk-free for
                  you
                </p>
              
                <p style={{ marginBottom: 0, fontSize: "15px", color: "#333" }}>
                    If you are not satisfied with our care for any reason within the <strong>first 30 days</strong>, we will provide a
                    <strong>90% refund (30 Days 90% Moneyback Guarranty. No Question Asked).</strong> No forms. No
                    hidden clauses. No questions asked. Your peace of mind is our top priority.
                </p>
              </div>
           </div>
         <div className="col-md-6 order-mobile">
           <img src="/PricingPage5.png" className="w-100" />
         </div>
      </div>
     </div>
   </div>

      <div className="bg-light">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/PricingPage6.png" className="w-100" />
            </div>
            <div className="col-md-6">
              <h2 className="hero-title text-red">
                Ready to Experience a Better Pregnancy Journey?
              </h2>
              <p className="bold-font" style={{paddingBottom: "10px"}}>This isn't about selling you a package. This is about inviting you to a new standard of care
                    where you are supported, heard, empowered, and celebrated every single day</p>
             <p className="bold-font">Your next step isn't a payment. It's a conversation.</p>
                <a
               href="#"
               onClick={handleCalendlyClick}
               className="round-btn btn-icon"
               style={{ textAlign: "center" }}
             >
               Talk to a Pregnancy Counsellor (Free)
             </a>
            </div>
          </div>
           <div className="footer-message" style={{ textAlign: "center" }}>
             <a
               href="/ebook/myprega.com-Digital-Broacher.pdf" 
               download
               className="cta-button"
               style={{
                 display: "inline-block",
                 padding: "12px 20px",
                 backgroundColor: "#013bfa",
                 color: "#fff",
                 fontWeight: "bold",
                 fontSize: "16px",
                 textDecoration: "none",
                 borderRadius: "32px",
                 transition: "background-color 0.3s ease",
               }}
               onMouseOver={(e) => (e.target.style.backgroundColor = "#a4103a")}
               onMouseOut={(e) => (e.target.style.backgroundColor = "#013bfa")}
             >
               Have more questions?
               <br />
               [Download Our Detailed Package Brochure]
             </a>
           </div>
        </div>
      </div>

      <Footer />
      <InteraktScript />
    </div>
  );
}

export default PricingPage;
